import { createPersistedState } from 'pinia-plugin-persistedstate'
import type { Pinia } from 'pinia'

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia as Pinia
  // Set sessionStorage as the default storage for the plugin
  pinia.use(createPersistedState({
    // Use browser sessionStorage directly because this file only runs client-side
    storage: sessionStorage
  }))
})
